import { createSelector } from "@ngrx/store";
import { AppStateInterface } from "../../appState.interface";

export const selectFeature = (state: AppStateInterface) => state.installations;

export const isLoadingSelector = createSelector(
    selectFeature, 
    (state) => state.isLoading
);

export const installationsSelector = createSelector(
    selectFeature, 
    (state) => state.installations
);

export const errorSelector = createSelector(
    selectFeature, 
    (state) => state.error
);